<script>
import Vue from "vue";
import { fetchData } from "@/api/oa";
import { formMap } from "@/assets/js/form";
import { isOwnApprovalBySource } from "@/utils/util";

let d = new RegExp("&#39;", "g"),
    tipsHtml = `<suspend-button v-if="ownApprovalFlag" @click="recordJump">审批<br/>记录</suspend-button><div class="number already-number">单号：{{bpmInst.billNo}}</div>
    <div
        v-if="bpmInst.status"
        class="approve-result"
        :class="[{'pullout': true},approvalStatus[bpmInst.status]]"
      ></div>`;

export default {
    name: "sscEndDetails",
    data() {
        return {
            action: false,
            iotApplicationForm: {
                hint: "项目总费用可调整",
            },
            template: null,
            urlTitle: "",
            payFill: false,
            instId: this.$route.query.instId,
            budget: {},
            currentType: "approvalEnd",
            formKey: null,
            bpmTask: {},
            permission: {},
            startUser: {},
            data: {},
            agreementList: [],
            toast: null,
            modelData: {},
        };
    },
    computed: {
        ownApprovalFlag() {
            return isOwnApprovalBySource(this.$route.query.source);
        },
    },
    watch: {
        $route(to, from) {
            // 对路由变化作出响应...
            (this.instId = this.$route.query.instId),
                this.getDetailsData(),
                this.setApproveHistoryInfo();
        },
    },
    render: function (createElement) {
        if (!this.template) {
            return createElement("div", "");
        } else {
            return this.template();
        }
    },
    created() {
        this.toast = this.$toast.loading({
            mask: false,
            message: "加载中...",
            duration: 0,
        });
        this.getDetailsData();
        this.setApproveHistoryInfo();
    },
    updated() {
        this.setTitle();
    },
    methods: {
        isJSON(str) {
            if (typeof str === "string") {
                try {
                    var obj = JSON.parse(str);
                    return true;
                } catch (e) {
                    return false;
                }
            } else {
                return false;
            }
        },
        setTitle() {
            this.$setIosTitle(this.urlTitle);
        },
        // 设置审批记录的url
        // c单穿透到A单 ， 希望可以看到A单的审批记录
        setApproveHistoryInfo() {
            let url = `${location.origin}/ssc/record/details?instId=${this.$route.query.instId}&appid=${this.$route.query.appid}&version=${this.$route.query.version}`;
            iqh.updateApproveInfo &&
                iqh.updateApproveInfo({
                    // "redirectURL": url,
                    rightTextClickURL: url,
                });
        },
        getDetailsData() {
            fetchData("getCompleteDetails", this.instId)
                .then((response) => {
                    this.toast.clear();

                    this.formKey = response.data.formModels[0].formKey;
                    this.bpmInst = response.data.bpmInst;
                    this.data = response.data.formModels[0].jsonData;
                    this.startUser = response.data.startUser;
                    this.modifyFn();

                    // this.bpmInst.status = 'DRAFTED222'
                    // 结算收入流程单 数据需要分类计算 单独处理
                    if (
                        this.formKey === "MFM_1200000003420182" ||
                        this.formKey === "MFM_2490000001719369"
                    ) {
                        this.modifyData();
                    }
                    // 设置title
                    if (this.formKey === "MFM_4760000020242478") {
                        this.data.category === "0"
                            ? (this.urlTitle = "资质/文件用章申请单")
                            : (this.urlTitle = "资质/文件/章类借出借用申请单");
                    } else {
                        this.urlTitle = response.data.formModels[0].description;
                    }

                    if (
                        this.formKey === "MFM_1100000019631020" &&
                        this.data.is_append !== "0"
                    ) {
                        fetchData("overallBudget", {
                            sourceCode: this.data.source_code,
                            totalBudget: this.data.total_budget,
                            instId: this.instId,
                        }).then((response) => {
                            if (response.data.success) {
                                this.budget = response.data.data;
                            }
                        });
                    }
                    if (formMap.get(this.formKey)) {
                        this.template = Vue.compile(
                            "<section class='approved_box'>" +
                                tipsHtml +
                                formMap.get(this.formKey).replace(d, "'") +
                                "</section>"
                        ).render;
                    } else {
                        this.template = Vue.compile(
                            "<section class='approved_box'>" +
                                tipsHtml +
                                response.data.formModels[0].content.replace(
                                    d,
                                    "'"
                                ) +
                                "</section>"
                        ).render;
                    }
                    // this.template = Vue.compile("<section class='approved_box already-box'>"+ tipsHtml + response.data.formModels[0].content.replace(d, "'") +"</section>").render;
                })
                .catch(() => {
                    this.toast.clear();
                    this.template = Vue.compile(
                        '<section><result type="network" subtext="要不然下拉刷新试试？"></result></section>'
                    ).render;
                });
        },
        modifyFn() {
            // 电子公章、（资质/文件用章、资质/文件/章类借出借用）
            if (
                this.formKey == "MFM_1100000029261543" ||
                this.formKey == "MFM_4760000020242478"
            ) {
                if (this.permission.approve_choose_form === "w") {
                    const approveChoose = this.data.approve_choose
                        ? this.data.approve_choose.split(",")
                        : [];
                    this.$set(this.modelData, "approve_choose", approveChoose);
                    this.$set(
                        this.modelData,
                        "none_approve",
                        !!this.data.none_approve
                    );
                }
            }
            // 资质/文件/章类借出借用
            if (this.formKey == "MFM_4760000020242478") {
                const secondClassif = this.data.second_classif
                    ? this.data.second_classif.split(",")
                    : [];
                this.modelData["isShowLicenseUse"] = secondClassif.some(
                    (type) => {
                        return type == "1010" || type == "1020";
                    }
                );
            }
        },
        // 结算收入流程
        modifyData() {
            let obj = {
                change: "变更",
                new: "新建",
                edit: "修改",
                invalid: "作废",
            };
            this.data.category_name = obj[this.data.category];
            let SUB_sm_flow_lines =
                this.data.SUB_sm_flow_lines ||
                this.data.SUB_sm_flow_reduce_lines;
            this.data.itemslength = SUB_sm_flow_lines.length;
            SUB_sm_flow_lines = SUB_sm_flow_lines.sort((a, b) => {
                a.amount - b.amount;
            });
            let SUB_sm_flow_items = SUB_sm_flow_lines.slice(0, 5);
            // 按照币种分类 并计算总额
            let SUB_sm_flow_currencys = [];
            //其他的大于5的金额合计计算
            let SUB_sm_flow_lines5 = [];

            // 减值结算流水单
            let total_amount = 0; // 减值金额
            let total_currency_amount = 0; // 原币币种合计金额
            SUB_sm_flow_lines.forEach((item, index) => {
                total_amount += item.reduce;
                total_currency_amount += item.amount;
                let idx = SUB_sm_flow_currencys.findIndex(
                    (dd) => dd.currency === item.currency
                );
                if (~idx) {
                    SUB_sm_flow_currencys[idx].amount += item.amount;
                } else {
                    SUB_sm_flow_currencys.push({
                        currency: item.currency,
                        currency_name: item.currency_name,
                        amount: item.amount,
                        reduce: item.reduce,
                    });
                }
                //从第5个开始计算
                if (index > 4) {
                    let idx5 = SUB_sm_flow_lines5.findIndex(
                        (dd) => dd.currency === item.currency
                    );
                    if (~idx5) {
                        SUB_sm_flow_lines5[idx].amount += item.amount;
                        SUB_sm_flow_lines5[idx].ar += item.ar;
                        SUB_sm_flow_lines5[idx].reduce += item.reduce;
                        SUB_sm_flow_lines5[idx].vendor_a_ap += item.vendor_a_ap;
                    } else {
                        SUB_sm_flow_lines5.push({
                            currency: item.currency,
                            currency_name: item.currency_name,
                            amount: item.amount,
                            ar: item.ar,
                            vendor_a_ap: item.vendor_a_ap,
                            reduce: item.reduce,
                        });
                    }
                }
            });
            this.data.SUB_sm_flow_items =
                SUB_sm_flow_items.concat(SUB_sm_flow_lines5);
            this.data.SUB_sm_flow_currencys = SUB_sm_flow_currencys;
            this.data.total_amount = total_amount;
            this.data.total_currency_amount = total_currency_amount;
        },
        // 跳转到审批记录
        recordJump() {
            const { instId, appid } = this.$route.query;
            this.$router.push({
                path: "/ssc/record/details",
                query: {
                    instId,
                    appid,
                },
            });
        },
    },

    beforeDestroy() {
        this.toast.clear();
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
.approve-result {
    top: -6px;
    right: 0;
}
</style>
